import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { queryClient } from '@service-initiation/shared-utils-query-client';
import { convertTimeSlotToTimestamp } from '@service-initiation/tech-care-utils-date-time';

import { techCareServicesClient } from './clients/techCareServicesClient';
import { invalidateCreateAppointmentIntentQuery } from './utils';

type DeleteAppointmentIntentProps = {
  appointmentDate: string;
  appointmentStartTime: string;
  intentId: string;
  storeId: number;
  storeTimeZone: string;
};

export const deleteAppointmentIntent = async (
  request: DeleteAppointmentIntentProps
): Promise<void> => {
  try {
    const result = await queryClient.fetchQuery({
      queryFn: async () => {
        const timeStamp = convertTimeSlotToTimestamp(
          request.appointmentDate,
          request.appointmentStartTime,
          request.storeTimeZone
        );
        const response = await techCareServicesClient.deleteAppointmentIntent({
          delete: true,
          intent_id: request.intentId,
          store_id: request.storeId,
          time: timeStamp,
        });

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Received invalid response status from server.');
        }

        if (response.body?.data.error || !response.body.data.result) {
          throw new Error('Failed to delete appointment intent.');
        }

        invalidateCreateAppointmentIntentQuery(request);
        return response.body.data.result;
      },
      queryKey: ['deleteAppointmentIntent', request],
      retry: 2,
      staleTime: Infinity,
    });

    if (!result) {
      throw new Error('Failed to delete appointment intent.');
    }

    return;
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to delete appointment intent.';
    logger.error(err, {
      data: request,
    });
    throw err;
  }
};
